import { defineMessages } from "react-intl";

const messages = defineMessages({
  room: {
    defaultMessage: "Room",
    id: "hotel.roomDetailsForm.room",
    description:
      'Label describing the number and order of the room. It will be followed with a number. Example: "Room 1" indicates it is the first room',
  },
  roomsListLabel: {
    defaultMessage: "Rooms list",
    id: "hotel.roomDetailsForm.roomsListLabel",
    description:
      "Aria label for the list of rooms in the room details form. Used for accessibility.",
  },
  adults: {
    defaultMessage: "Adults",
    id: "hotel.roomDetailsForm.adults",
    description:
      'Label describing the number of adults staying in the room. Example: "Adults - 5" indicates there are 5 adults staying in the room.',
  },
  children: {
    defaultMessage: "Children",
    id: "hotel.roomDetailsForm.children",
    description:
      'Label describing the number of children staying in the room. Example: "Children - 3" indicates there are 3 children staying in the room.',
  },
  reset: {
    defaultMessage: "reset",
    id: "hotel.roomDetailsForm.reset",
    description:
      "The text on the button that resets any changes the user has made to room details. All data related to the room will be erased.",
  },
  addAnotherRoom: {
    defaultMessage: "add another room",
    id: "hotel.roomDetailsForm.addAnotherRoom",
    description:
      "The text on the button that adds a new room to room details form when a user wants to book multiple rooms. A new room with default guests information will be shown.",
  },
  removeRoom: {
    defaultMessage: "remove room",
    id: "hotel.roomDetailsForm.removeRoom",
    description:
      "The text on the button that removes the most recently added room from the room details form.",
  },
  childAgeSelect: {
    defaultMessage: "Age",
    id: "hotel.roomDetailsForm.childAgeSelect",
    description:
      "Label for a dropdown in where the user can select a number to indicate the age of a child. 0 to 17.",
  },
  childAgeOptionSingle: {
    id: "hotel.roomDetailsForm.childAgeOptionSingle",
    description:
      'Label for a selectable option for a child of age 1 e.g. "1 year old".',
    defaultMessage: "1 year old",
  },
  childAgeOptionMultiple: {
    id: "hotel.roomDetailsForm.childAgeOptionMultiple",
    description:
      'Label for a selectable option for a child of multiple years old e.g. "3 years old".',
    defaultMessage: "{age} years old",
  },
  childLabel: {
    defaultMessage: "Child {number}",
    id: "hotel.roomDetailsForm.childLabel",
    description: "Label for a child age selector, e.g., 'Child 1'",
  },
  adultAddLabel: {
    id: "hotel.roomDetailsForm.adultAddLabel",
    defaultMessage: "Add adult guest",
    description: "Label for the button that adds an adult to the room.",
  },
  adultRemoveLabel: {
    id: "hotel.roomDetailsForm.adultRemoveLabel",
    defaultMessage: "Remove adult guest",
    description: "Label for the button that removes an adult from the room.",
  },
  childAddLabel: {
    id: "hotel.roomDetailsForm.childAddLabel",
    defaultMessage: "Add child guest",
    description: "Label for the button that adds a child to the room.",
  },
  childRemoveLabel: {
    id: "hotel.roomDetailsForm.childRemoveLabel",
    defaultMessage: "Remove child guest",
    description: "Label for the button that removes a child from the room.",
  },
});

export default messages;
